module.exports = __webpack_public_path__ + "img/teeth-28.a0cb1fa5.png";